import React from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { LogoMark } from "./LogoMark";
type IntroOverlayProps = {
  visible: boolean;
};
export function IntroOverlay({
  visible
}: IntroOverlayProps) {
  const reducedMotion = useReducedMotion();
  const duration = reducedMotion ? 0.01 : 0.8;
  return <AnimatePresence data-id="element-78" data-mp="1kyjzfm50ps78">
      {visible && <motion.div className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden bg-white" initial={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: reducedMotion ? 0.01 : 0.5,
      ease: [0.22, 1, 0.36, 1]
    }} aria-hidden="true" data-id="element-79" data-mp="x8fyjmj7s6jx">
          <motion.span className="absolute bottom-0 left-[7vw] top-0 w-px bg-[#033448]/15" initial={{
        scaleY: 0
      }} animate={{
        scaleY: 1
      }} transition={{
        duration
      }} data-id="element-80" data-mp="119javz21zkge" />
          <motion.span className="absolute bottom-0 right-[7vw] top-0 w-px bg-[#033448]/15" initial={{
        scaleY: 0
      }} animate={{
        scaleY: 1
      }} transition={{
        duration
      }} data-id="element-81" data-mp="2hq43b8fb4doq" />
          <div className="flex w-full max-w-xl flex-col items-center px-8 text-center" data-id="element-82" data-mp="2dsonetdik9kv">
            <motion.p className="mb-7 font-sans text-[10px] font-semibold tracking-[0.32em] text-[#566C63]" initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: reducedMotion ? 0 : 0.1
        }} data-id="element-83" data-mp="2htibbmqyhodr">UMA CASA EM ANGRA DOS REIS</motion.p>
            <motion.div className="w-[min(62vw,280px)]" initial={{
          opacity: 0,
          y: 14,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} transition={{
          duration,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-84" data-mp="1u5qymi1i79by"><LogoMark className="h-auto w-full" title="" data-id="element-85" data-mp="243ewhgueowyc" /></motion.div>
            <div className="mt-7 h-px w-32 overflow-hidden bg-[#D4B581]/25" data-id="element-86" data-mp="2423ot5xub51y">
              <motion.div className="h-full w-1/3 bg-[#D4B581]" initial={{
            x: reducedMotion ? 0 : -44
          }} animate={{
            x: reducedMotion ? 0 : 128
          }} transition={{
            duration: 0.9,
            repeat: reducedMotion ? 0 : Infinity,
            ease: [0.25, 1, 0.5, 1]
          }} data-id="element-87" data-mp="28uwtxux80fek" />
            </div>
            <motion.p className="mt-6 font-serif text-2xl italic text-[#172B32]" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: reducedMotion ? 0 : 0.25
        }} data-id="element-88" data-mp="18cwc6kas3gc6">O seu tempo, no seu lugar.</motion.p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}